import { z } from "zod";
export const DTOGitOrganization = z.object({
    id: z.string(),
    name: z.string(),
    url: z.string(),
    slug: z.string(),
});
export const DTOGitProject = z.object({
    id: z.string(),
    name: z.string(),
    url: z.string(),
    slug: z.string(),
});
export const DTOGitRepository = z.object({
    id: z.string(),
    name: z.string(),
    url: z.string(),
    slug: z.string(),
    defaultBranch: z.string().optional(),
});
export const DTOGitBranch = z.object({
    name: z.string(),
    lastCommitId: z.string(),
});
